import project_base from './base/router'
export default [
    {
        path: 'project',
        name: 'project',
        component: r => require.ensure([], () => r(require('./index.vue')), 'project'),
        children: [
            project_base,
        ]
    }]
